import React, { useEffect, useState, useCallback } from 'react';

import {
  Form,
  FormGroup,
  DatePicker,
  DatePickerInput,
  NumberInput,
  Toggle,
  Button,
} from '@carbon/react';
//import { accordion_inner } from './SettingsPage.module.scss';

import '../_settings.scss';

export const BundesligaSettings = ({ item: propsItem, onSave }) => {
  useEffect(() => {
    if (propsItem && propsItem.model) {
      setSettings({
        ...propsItem,
        ID: propsItem.model.ID,
        settings: '',
      });
      console.info('propsItem:', propsItem);
    }
  }, [propsItem]);

  const [settings, setSettings] = useState({
    ID: 0,
    enabled: false,
    duration: 5,
    media_duration: 0,
    media_valid_from: '',
    media_valid_through: '',
    settings: '',
  });

  const changeHandle = useCallback(
    (field, value) => {
      let fa = { ...settings };
      fa[field] = value;
      setSettings(fa);
    },
    [settings]
  );

  const changeDateRange = useCallback(
    (start, ende) => {
      let fa = { ...settings };
      fa['media_valid_from'] = start;
      fa['media_valid_through'] = ende;
      setSettings(fa);
    },
    [settings]
  );

  const handleSave = useCallback(() => {
    onSave(settings);
  }, [onSave, settings]);

  return (
    <Form>
      <FormGroup legendText="Details">
        <DatePicker
          id="field_for_datepicker_group"
          datePickerType="range"
          dateFormat="d.m.Y"
          onChange={(e) => {
            changeDateRange(e[0], e[1]);
          }}
          value={[settings.media_valid_from, settings.media_valid_through]}>
          <DatePickerInput
            id="features-bundesliga-start"
            placeholdr="dd.mm.yyyy"
            labelText="Start"
            pattern="\\d{4}-\\d{1,2}-\\d{1,2}"
          />
          <DatePickerInput
            id="features-bundesliga-end"
            placeholdr="dd.mm.yyyy"
            labelText="Ende"
            pattern="\\d{1,2}.\\d{1,2}.\\d{4}"
          />
        </DatePicker>

        <NumberInput
          id="field_for_duration"
          label="Standard Anzeigedauer in Sekunden"
          min={6}
          max={30}
          value={settings.duration}
          onChange={(_e, {value, direction}) => {
            if (value > 0) {
              changeHandle('duration', Number(value));
            } else {
              changeHandle(
                'duration',
                direction === 'up' ? settings.duration + 1 : settings.duration - 1
              );
            }
          }}
          helperText="Wielange soll ein Bild angezeigt werden"
        />

        <NumberInput
          id="field_for_interval_duration"
          label="Standard Anzeige Interval"
          min={2}
          max={6}
          value={settings.interval_duration}
          onChange={(_e, {value, direction}) => {
            if (value > 0) {
              changeHandle('interval_duration', Number(value));
            } else {
              changeHandle(
                'interval_duration',
                direction === 'up'
                  ? settings.interval_duration + 1
                  : settings.interval_duration - 1
              );
            }
          }}
          helperText="Wie häufig soll das Bild angezeigt werden"
        />
      </FormGroup>
      <Button onClick={handleSave}>Speichern</Button>
    </Form>
  );
};
